import styled from "styled-components";

export const HeaderWrapper = styled.header`
	background: ${props => props.theme.white};
	display: flex;
	align-items: center;
	height: 7rem;
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	z-index: 2147483641;
	border-bottom: 1px solid #D8D8D8;
	@media ${props => props.theme.media.large} {
		height: 120px;
	}
	@media ${props => props.theme.media.smallLandscape} {
		height: 3rem;
	}
	h1 {
		font-size: 30px;
		font-weight: 700;
		padding-top: 3rem;
		@media ${props => props.theme.media.smallLandscape} {
			font-size: 1.6rem;
		}
		@media ${props => props.theme.media.large} {
			font-size: 30px;
			font-weight: 700;
			padding-top: 3rem;
		}
	}

	.isMobile {
		gap: 8px;
	}
`;
export const HeaderInner = styled.div`
	width: 120rem;
	margin: 0 auto;
	display: flex;
	align-items: center;
	gap: 16px;
	justify-content: start;
	font-weight: bold;
	font-family: ${props => props.theme.fonts.heading};
	padding-left: 1.5rem;
	padding-right: 4rem;
	@media ${props => props.theme.media.large} {
		padding-left: 10rem;
		padding-right: 2rem;
	}
	@media ${props => props.theme.media.extraLarge} {
		padding-left: 0;
		padding-right: 0;
	}

	.backParagraph {
		font-size: 1.4rem;
		font-weight: 700;
		color: #008755;
	}
`;



export const HeaderCloseButton = styled.button`
	position: relative;
	padding-top: 1rem;
	@media ${props => props.theme.media.large} {
		padding-top: 0.8rem;
		margin-top: 3.7rem;
	}
	padding-right: 2rem;
`;

export const HeaderCloseButtonText = styled.span`
	font-size: 1.6rem;
	font-family: ${props => props.theme.fonts.heading};
	color: ${props => props.theme.lightGreen};
	display: none;

	@media ${props => props.theme.media.large} {
		display: inline;
	}
`;

export const HeaderCloseIcon = styled.span`
	background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDNDMCAxLjM0MzE1IDEuMzQzMTUgMCAzIDBIOEM4LjU1MjI4IDAgOSAwLjQ0NzcxNSA5IDFDOSAxLjU1MjI4IDguNTUyMjggMiA4IDJIM0MyLjQ0NzcyIDIgMiAyLjQ0NzcyIDIgM1YxMUMyIDExLjU1MjMgMi40NDc3MiAxMiAzIDEySDhDOC41NTIyOCAxMiA5IDEyLjQ0NzcgOSAxM0M5IDEzLjU1MjMgOC41NTIyOCAxNCA4IDE0SDNDMS4zNDMxNSAxNCAwIDEyLjY1NjkgMCAxMVYzWk00IDdDNCA2LjQ0NzcyIDQuNDQ3NzIgNiA1IDZIMTAuNTg0NUw5LjI5MjUzIDQuNzA2NzVDOC45MDIyMSA0LjMxNjAzIDguOTAyNTMgMy42ODI4NiA5LjI5MzI1IDMuMjkyNTRDOS42ODM5NyAyLjkwMjIxIDEwLjMxNzEgMi45MDI1MyAxMC43MDc1IDMuMjkzMjZMMTMuNzA0NCA2LjI5MzI1QzE0LjA5NDUgNi42ODM2OSAxNC4wOTQ1IDcuMzE2MyAxMy43MDQ0IDcuNzA2NzVMMTAuNzA3NSAxMC43MDY3QzEwLjMxNzEgMTEuMDk3NSA5LjY4Mzk3IDExLjA5NzggOS4yOTMyNSAxMC43MDc1QzguOTAyNTMgMTAuMzE3MSA4LjkwMjIgOS42ODM5OCA5LjI5MjUzIDkuMjkzMjZMMTAuNTg0NSA4SDVDNC40NDc3MiA4IDQgNy41NTIyOCA0IDdaIiBmaWxsPSIjMDA4NzU1Ii8+Cjwvc3ZnPgo=")
		no-repeat center center;
	content: "";
	width: 6.6rem;
	height: 3.6rem;
	position: absolute;
	left: 0;
	top: 2.2rem;
	@media ${props => props.theme.media.smallLandscape} {
		top: 2.5rem;
	}
	@media ${props => props.theme.media.large} {
		left: 1.2rem;
		top: 0.1rem;
	}
`;
